import { render } from "./test_circle.svg?vue&type=template&id=6be25f88"
const script = {}
script.render = render

export default script